import {inject} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {IFilterOptionDef, INumberFilterParams} from 'ag-grid-community';
import {getBasicFilterParams} from '../../../get-basic-filter-params/get-basic-filter-params';

export function getBooleanFilterParams(): INumberFilterParams {
  const translateService = inject(TranslateService);

  return {
    ...getBasicFilterParams(),
    filterOptions: [
      'empty',
      {
        displayKey: 'eq_true',
        displayName: translateService.instant('SHARED_LABEL_YES'),
        predicate: (_, cellValue) => +cellValue === 1,
        numberOfInputs: 0,
      },
      {
        displayKey: 'eq_false',
        displayName: translateService.instant('SHARED_LABEL_NO'),
        predicate: (_, cellValue) => +cellValue === 0,
        numberOfInputs: 0,
      },
      {
        displayKey: 'boolean_blank',
        displayName: translateService.instant('SHARED_LABEL_BLANK'),
        predicate: (_, cellValue) =>
          cellValue === null || cellValue === undefined,
        numberOfInputs: 0,
      },
      {
        displayKey: 'boolean_notBlank',
        displayName: translateService.instant('SHARED_LABEL_NOT_BLANK'),
        predicate: (_, cellValue) =>
          cellValue !== null && cellValue !== undefined,
        numberOfInputs: 0,
      },
    ] as IFilterOptionDef[],
  };
}
